<script>
import { storeForms } from '@app/mixins/forms';

export default {
  mixins: [storeForms],
  data() {
    return {
      store: {
        feature_options: {
          customer_session: {
            display_time_to_customer: false,
          },
        },
      },
    };
  },
};
</script>

<template>
  <div class="columns">
    <div class="column is-4 content pr-10 is-small">
      <h2 class="is-size-5">
        Affichage des temps de connexion
      </h2>
      <p>
        Activez cette option pour afficher à vos apprenant leur temps de connexion
        par formation, directement sur leur tableau de bord.
      </p>
      <p>
        <b>
          Configurez la façon dont vous calculez les temps de connexion en
          <router-link :to="{name: 'trainings_settings'}">
            cliquant ici.
          </router-link>
        </b>
      </p>
    </div>

    <div class="column">
      <form class="box content" @submit.prevent="dataIsValid(isLoading) && handle()">
        <b-field>
          <b-switch v-model="store.feature_options.customer_session.display_time_to_customer">
            Afficher les temps de connexion côté apprenant
          </b-switch>
        </b-field>

        <div class="buttons is-right">
          <b-button type="is-primary" native-type="submit" :loading="isLoading">
            Mettre à jour
          </b-button>
        </div>
      </form>
    </div>
  </div>
</template>
